import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { X, AlertCircle } from 'lucide-react';

function ErrorSnackbar({ message, onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 6000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-2 duration-300">
      <div
        className="flex items-center gap-3 px-4 py-3 rounded-lg bg-destructive text-destructive-foreground shadow-lg"
        style={{ minWidth: '300px' }}
      >
        <AlertCircle className="h-5 w-5 flex-shrink-0" />
        <p className="text-sm flex-1">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="text-destructive-foreground/80 hover:text-destructive-foreground transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

ErrorSnackbar.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ErrorSnackbar.defaultProps = {
  message: null,
};

export default ErrorSnackbar;
